import { editStatusFilter, personIdentifierFilter, personStatusFilter } from '../../Vocabulary/data';
import { QueryFacet } from '../../pages/dashboard/SearchResults';
import { FacetLabel, FacetSetting } from '../../util/types';
import { idHashFilter } from '../../pages/dashboard/utils';
import { HierarchyEntity } from '../data';

export const personFacetsSettings: FacetSetting[] = [
  {
    name: 'f_top_orga',
    label: 'search.facet.person.top_orga',
    missingLabel: 'search.facet.person.top_orga.missing',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_person_status',
    label: 'search.facet.person.person_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => personStatusFilter(label),
  },
  {
    name: 'f_organisation',
    label: 'search.facet.person.organisation',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_project',
    label: 'search.facet.person.project',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.PROJECTS),
  },
  {
    name: 'f_external_identifier',
    label: 'search.facet.person.external_identifier',
    tristate: true,
    parse: (facet: QueryFacet): string => `${facet.factor === false ? '-' : ''}${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => personIdentifierFilter(label),
  },
  {
    name: 'f_editorial_status',
    label: 'search.facet.person.editorial_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => editStatusFilter(label),
  },
  {
    name: 'f_data_last_supplied',
    label: 'search.facet.person.data_last_supplied',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => label,
  },
];
